<template>
  <div class="section group">
    <div class="col span_1_of_2">
      <div>
        <input
          class="productName inactive"
          type="text"
          v-model="product.name"
          maxlength="18"
          :disabled="!isEditing"
          :class="{ active: !isActive, view: !isEditing }"
          @blur="$v.product.name.$touch()"
        />
        <template v-if="$v.product.name.$error">
          <div v-if="!$v.product.name.required" class="errorMessage">{{ $t('expNameReq') }}</div>
        </template>
      </div>
      <div class="productData" v-if="category">
        <div class="formInput">
          {{ $tc('category', 1) }}:
          <strong v-if="!isEditing">{{ category.name }}</strong>
          <multiselect
            v-else
            v-model="category"
            :options="categoryNames"
            :searchable="false"
            :close-on-select="true"
            track-by="id"
            label="name"
            :placeholder="$t('selectExpCat')"
            :show-labels="false"
            @change="categorySelect"
          ></multiselect>
        </div>

        <div class="formInput" v-if="supplier">
          {{ $t('supplierExp') }}:
          <strong v-if="!isEditing">{{ supplier.name }}</strong>
          <multiselect
            v-else
            v-model="supplier"
            :options="supplierNames"
            :searchable="false"
            :close-on-select="true"
            track-by="id"
            label="name"
            :placeholder="$t('selectSupplier')"
            :show-labels="false"
            @change="supplierSelect"
          ></multiselect>
        </div>

        <div class="formInput">
          <span>{{ $t('expDesc') }} ({{ $t('prodDescLength') }}): </span>
          <b-form-textarea
            v-model="product.description"
            type="text"
            class="inactive"
            :state="product.description.length <= 300"
            :disabled="!isEditing"
            @blur="$v.product.description.$touch()"
            :class="{ active: !isActive, view: !isEditing }"
          ></b-form-textarea>
          <template v-if="$v.product.description.$error">
            <div v-if="!$v.product.description.required" class="errorMessage">{{ $t('expDescReq') }}</div>
          </template> 
          <template v-if="$v.product.description.$error">
            <div v-if="!$v.product.description.maxLength" class="errorMessage">{{ $t('taglineMaxLength') }}</div>
          </template>
        </div>

        <div class="formInput">
          <span>{{ $t('priceRange') }} (eur): </span>
          <input
            type="number"
            class="inactive"
            v-model="product.price_min"
            :disabled="!isEditing"
            :class="{ active: !isActive, view: !isEditing }"
            @blur="$v.product.price_min.$touch()"
          />
          <template v-if="$v.product.price_min.$error">
            <div v-if="!$v.product.price_min.required" class="errorMessage">{{ $t('minPriceReq') }}</div>
          </template>
          <input
            type="number"
            class="inactive"
            v-model="product.price_max"
            :disabled="!isEditing"
            :class="{ active: !isActive, view: !isEditing }"
            @blur="$v.product.price_max.$touch()"
          />
          <template v-if="$v.product.price_max.$error">
            <div v-if="!$v.product.price_max.required" class="errorMessage">{{ $t('maxPriceReq') }}</div>
          </template>
        </div>
        <div class="formInput">
          <span>{{ $t('url') }}: </span>
          <input
            type="text"
            class="inactive"
            v-model="product.url"
            :disabled="!isEditing"
            @blur="$v.product.url.$touch()"
            :class="{ active: !isActive, view: !isEditing }"
          />
          <template v-if="$v.product.url.$error">
            <div v-if="!$v.product.url.required" class="errorMessage">{{ $t('urlReq') }}</div>
          </template> 
          <template v-if="$v.product.url.$error">
            <div v-if="!$v.product.url.url" class="errorMessage">{{ $t('validUrlReq') }}</div>
          </template>
        </div>
        <div class="save-btn-box">
          <button :disabled="$v.$invalid" class="edit-btn" v-if="isEditing" @click="changeProductDetails">
            <font-awesome-icon class="icon" icon="save" />
            <span> {{ $t('save') }} </span>
          </button>
        </div>

      </div>

      <br />
      <div
        class="edit-btn"
        @click="
          isEditing = !isEditing
          isActive = !isActive">
        <font-awesome-icon class="icon" icon="edit" />
        <span> {{ $t('changeDetails') }} </span>
      </div>

      <!-- <div @click="$bvModal.show('qrcode-modal')" class="trash-btn">
        <font-awesome-icon class="icon" icon="qrcode" /><span>
          {{ $t('getQRcode') }}</span>
      </div> -->
      <br />
      <div class="edit-btn" @click="deleteProduct">
        <font-awesome-icon class="icon" icon="trash" /><span>
          {{ $t('removeExperience') }}</span
        >
      </div>
    </div>

    <div class="col span_1_of_2">
      <ProductImageUpload
        :isProductFlowEnabled="false"
        :experienceId="product.id"
        :productId="0"
        :imageUrl="product.img_path"
      />

      <videoUpload :isProductFlowEnabled="false" :product="product" />
    </div>
    <b-modal id="qrcode-modal" body-class="hide-padding" hide-footer>
      <template v-slot:modal-title>
        <div>
          <div id="textbox1">{{ baseUrl }}/experience/{{ product.uuid }}</div>
          <br />
          <div>
            <qrcode-vue
              id="qrcode"
              :value="`${baseUrl}/experience/${product.uuid}`"
              size="100"
              level="H"
            ></qrcode-vue>
            <br />
            <div class="trash-btn" @click="downloadExperienceQRCodePdf">
              {{ $t('downloadPDF') }}
            </div>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import videoUpload from '@/components/ui/videoUpload.vue'
import ProductImageUpload from '@/components/ui/ProductImageUpload.vue'
import axios from 'axios'
import QrcodeVue from 'qrcode.vue'
import { jsPDF } from 'jspdf'
import { required, url, maxLength } from 'vuelidate/lib/validators'


export default {
  components: {
    videoUpload,
    ProductImageUpload,
    QrcodeVue,
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASE_URL,
      id: this.product.id,
      isEditing: false,
      isActive: false,
      categoryNames: [],
      supplierNames: [],
      category: null,
      supplier: null,
    }
  },
    validations: {
      product: {
        name: { required },       
        description: { required, maxLength:maxLength(300) },
        price_min: { required },
        price_max: { required }, 
        url: { required, url },        
      }
  },
  mounted() {
    axios
      .all([
        axios.get(`${process.env.VUE_APP_API_URL}/experienceCategories`),
        axios.get(`${process.env.VUE_APP_API_URL}/suppliers`),
      ])
      .then(
        axios.spread((productCategoriesRes, suppliersRes) => {
          this.categoryNames = productCategoriesRes.data
          this.category = this.categoryNames.find(
            (option) => option.id === this.product.expCat_id
          )

          this.supplierNames = suppliersRes.data
          this.supplier = this.supplierNames.find(
            (option) => option.id === this.product.supplier_id
          )
        })
      )
  },
  methods: {
    deleteProduct() {
      if (confirm('Ste prepričani? S tem boste izbrisali izkušnjo iz kataloga!')) {
        this.$store
          .dispatch('experience/removeExperience', this.id)
          .then(() => {
            this.$router.push({
              path: '/products/en',
            })
          })
          .catch((e) => console.log(e))
      }
    },
    downloadExperienceQRCodePdf() {
      const qrcode = document.getElementById('qrcode')
      let qrCanvas = qrcode.firstChild

      const imgData = qrCanvas.toDataURL('image/png')
      const doc = new jsPDF('p', 'mm', 'a4')

      doc.text(
        doc.splitTextToSize(
          `${this.baseUrl}/experience/${this.product.uuid}`,
          180
        ),
        10,
        30
      )

      doc.setFont('Lato-Regular', 'normal')
      doc.addImage(imgData, 'PNG', 30, 40, 100, 100)
      doc.text(`Expereince Name`, 10, 160)
      doc.text(`Expereince Category`, 10, 170)

      doc.setFont('Lato-Regular', 'bold')
      doc.text(`${this.product.name}`, 60, 160)
      doc.text(`${this.category.name}`, 60, 170)

      doc.save(`QR-Code:${this.product.id}.pdf`)
    },
    changeProductDetails() {
      if (
        confirm('are you sure? This will rewrite excisting experience details')
      ) {
        this.$store.dispatch(
          'experience/upsertExperience',
          this.generateExpereinceJson()
        )
        this.isEditing = !this.isEditing
        this.isActive = !this.isActive
      }
    },
    generateExpereinceJson() {
      const experience = {
        id: this.product.id,
        client_id: this.product.client_id,
        expCat_id: this.category.id,
        supplier_id: this.supplier.id,
        name: this.product.name,
        description: this.product.description,
        price_min: this.product.priceMin,
        price_max: this.product.priceMax,
        url: this.product.url,
      }
      return experience
    },
    categorySelect(option) {
      this.category = option
    },
    supplierSelect(option) {
      this.supplier = option
    },
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.productName {
  text-align: center;
  padding-left: 50px;
  font-size: 3em;
  width: 60%;
  // margin-bottom: 1.5rem;
}
.uploadDetails {
  font-size: 1.3em;
}
.formInput {
  text-align: left;
  margin-bottom: 5px;
}

.about-img3 {
  display: inline-block;
  width: 100%;
  max-width: 400px;
  text-align: center;
  vertical-align: top;
}
.uploadExample {
  max-width: 200px;
  width: 100%;
}

.errorMessage {
  margin-bottom: 0.2em;
  color: var(--primaryDark);
  font-size: 0.8em;
}

.productData {
  background: var(--grey-light);
  padding: 10px;
  border-radius: 15px;
}
.edit-btn {
  background: var(--primary);
  color: var(--bright);
  padding: 0.5em;
  margin: auto !important;
  letter-spacing: 3px;
  border: none;
  border-radius: 3.5px;
  width: 230px;
  height: 40px;
  text-align: left;
}

.save-btn {
    background: var(--primary);
    color: var(--bright);
    padding: 0.4em;
    margin: auto !important;
    letter-spacing: 3px;
    border: none;
    border-radius: 3.5px;
    height: 38px;
    text-align: center;
    width: 120px;
}

.save-btn-box {
  margin-top: 10px; 
}
  .trash-btn {
    height: 30px;
  }

  .icon {
    font-size: 1.3em;
    padding: 1px;
  }
  .active {
    border-radius: 3.5px;
    background: none !important;
    font-weight: 600;
    font-style: normal !important;
  }
  .inactive {
    background-color: var(--primarySuperLight);
    border-radius: 3.5px;
    font-style: italic;
  }
  .activeSlide {
    background: none;
  }


button:disabled,
button[disabled]{
  border: 1px solid #999999;
  background-color: #cccccc;
  color: #666666;
  cursor: context-menu;
}

textarea {
  padding: 10px;
  width: 100%;
  height: 180px;
}

/*  SECTIONS  */
.section {
  clear: both;
  padding: 0px;
  margin: 0px;
}

/*  COLUMN SETUP  */
.col {
  display: block;
  float: left;
  margin: 1% 0 1% 2%;
}
.col:first-child {
  margin-left: 0;
}

/*  GROUPING  */
.group:before,
.group:after {
  content: '';
  display: table;
}
.group:after {
  clear: both;
}
.group {
  zoom: 1; /* For IE 6/7 */
}

/*  GRID OF TWO  */
.span_2_of_2 {
  width: 100%;
}
.span_1_of_2 {
  width: 49%;
}

/*  GO FULL WIDTH AT LESS THAN 480 PIXELS */

@media only screen and (max-width: 480px) {
  .span_2_of_2,
  .span_1_of_2 {
    width: 100%;
  }
  .col {
    margin: 1% 0 1% 0%;
  }
  .input {
    width: 100%;
  }
  .formInput {
    margin: 1rem;
  }
  .productName {
    font-size: 2em;
    font-weight: 600;
    padding-left: 0;
    width: 90%;
  }
  .product-page div {
    text-align: left;
    margin-left: 20px;
  }
  textarea {
    width: 100%;
    height: 150px;
  }
  .uploadDetails {
    font-size: 1.2em;
  }
}

@media screen and (min-width: 800px) {
  .productData {
    padding: 50px;
  }
}
</style>
